import { Injectable, isDevMode, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { take } from 'rxjs';
import { SignupModalComponent } from './signup-modal/signup-modal.component';
import { SignupData } from './SignupData';
import { UserService } from '../shared/services/user.service';
import { ProfileService } from '../shared/services/profile.service';
import { LocaleSessionService } from '../shared/services/localeSession.service';
import { ProfileDto } from '../../api-auth';

@Injectable({
  providedIn: 'root',
})
export class SignupHandlerService {
  private dialog = inject(MatDialog);
  private userService = inject(UserService);
  private profileService = inject(ProfileService);
  private localeService = inject(LocaleSessionService);

  get isUserRegistered(): boolean {
    return this.#isUserRegistered;
  }

  #isUserRegistered = false;

  constructor() {
    this.profileService
      .get()
      .pipe(take(1))
      .subscribe((userData: ProfileDto) => {
        // console.log('-> userData', userData);
        this.userService.userData.next(userData);
        // At Auth0 we save information about language in user_metadata.lang
        const lng = userData.user_metadata?.lang;
        if (lng) this.localeService.changeLanguage(lng);
        this.checkUserStatus();
        // if (!this.isUserRegistered) this.openSignupModal();
      });
  }

  checkUserStatus() {
    if (!localStorage.getItem('force-register-form')) this.#isUserRegistered = true;
    // else console.log('-> this.userService.userData', this.userService.userData.value);
  }

  openSignupModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      email: this.userService.userData.value.email,
    };
    this.dialog
      .open(SignupModalComponent, dialogConfig)
      .afterClosed()
      .pipe(take(1))
      .subscribe((result: SignupData) => {
        if (!result) return this.openSignupModal();
        this.registerUser(result);
      });
  }

  registerUser(result: SignupData) {
    if (isDevMode()) console.log('-> result', result);

    // if ok
    this.#isUserRegistered = true;
  }
}
